module.exports = __webpack_public_path__ + "static/media/onlineshop.857226d9.jpg";